function getCapolConfig(){
    let capolXServer = process.env.VUE_APP_BIMV_API_CAPOLX;
    if (process.env.VUE_APP_ENV == 'domain') {
        capolXServer = window.location.origin + '/capolx'
    }

    return {
        capolXServer,
    }
}
function getBimConfig(){
    let apiRoot = process.env.VUE_APP_API_ROOT;
    let route = process.env.VUE_APP_API_ROUTE;
    if (process.env.VUE_APP_ENV == 'domain') {
        apiRoot = window.location.origin
    }

    return {
        apiRoot,
        route
    }
}
function getApiRoot(url){
    let apiRoot = getBimConfig().apiRoot;
    let list = ['design-board']
    if(!list.includes(url.split('/')[1])){
        //判断接口请求是否需要拼接design
        apiRoot += getBimConfig().route
    }
    return apiRoot
}
export default {
    capolConfig: getCapolConfig(),
    bimConfig: getBimConfig(),
    getApiRoot
}
